import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { CronService } from '../cron.service';
import { AddCron } from '../cron.interface';

@Component({
    selector: 'app-add-cron',
    templateUrl: './add-cron.component.html',
    styleUrls: ['./add-cron.component.scss'],
})
export class AddCronComponent implements OnInit {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    filterParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    // activeOptions: { name: string; id: number }[] = [
    //     {
    //         name: '--Alegeți--',
    //         id: -1,
    //     },
    //     {
    //         name: 'Active',
    //         id: 0,
    //     },
    //     {
    //         name: 'Inactive',
    //         id: 1,
    //     }
    // ];

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        slug: new FormControl('', [Validators.required]),
        path: new FormControl('', [Validators.required]),
        // active: new FormControl(-1, [Validators.required, notDefaultValidator('-1')]),
        interval: new FormControl('', [Validators.required]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddCronComponent>,
        private requestService: CronService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() { }

    submitForm() {
        this.isLoading = true;

        const payload: AddCron = {
            name: this.form.get('name')?.value,
            slug: this.form.get('slug')?.value,
            path: this.form.get('path')?.value,
            // active: this.form.get('active')?.value,
            interval: this.form.get('interval')?.value,
        };

        this.requestService
            .storeEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
